import { AiOutlineMail } from '@react-icons/all-files/ai/AiOutlineMail';
import { BsChat } from '@react-icons/all-files/bs/BsChat';
import { FiFacebook } from '@react-icons/all-files/fi/FiFacebook';
import { FiInstagram } from '@react-icons/all-files/fi/FiInstagram';
import { IoMdCall } from '@react-icons/all-files/io/IoMdCall';
import { MdTranslate } from '@react-icons/all-files/md/MdTranslate';
import React from 'react';
import type { NavigationsType } from './types';

const navigationData: NavigationsType = {
    headerNavigations: [
        {
            title: 'sidebar.home',
            defaultTitle: 'Home',
            path: 'https://www.trades.org',
        },
        {
            title: 'sidebar.marketing',
            defaultTitle: 'Marketing Services',
            path: 'https://www.trades.org/trade-pro/marketing-services',
        },
        {
            title: 'sidebar.operations',
            defaultTitle: 'Operations Support',
            path: 'https://www.trades.org/trade-pro/operations',
        },
        {
            title: 'sidebar.personal',
            defaultTitle: 'For you and your family',
            path: 'https://www.trades.org/trade-pro/personal',
        },
        {
            title: 'sidebar.contact',
            defaultTitle: 'Contact Us',
            path: 'https://www.trades.org/trade-pro/contact',
        },
    ],
    navbarItems: [
        {
            icon: <MdTranslate size={20} fill="#888" />,
            type: 'dropdown-language',
            options: [
                {
                    value: 'English',
                    locale: 'en',
                    link: '/',
                },
                {
                    value: 'Español',
                    locale: 'es-US',
                    link: '/es',
                },
            ],
        },
        {
            icon: <AiOutlineMail size={20} fill="#888" />,
            href: 'mailto:contact@trades.org',
            type: 'link',
        },
        {
            icon: <BsChat size={20} fill="#888" />,
            href: 'tel:(512)-729-3544',
            type: 'link',
        },
        {
            icon: <IoMdCall size={20} fill="#888" />,
            href: 'tel:(512)-729-3544',
            type: 'link',
        },
    ],
    footer: {
        headings: [
            {
                title: 'footer.marketing.title',
                defaultTitle: 'For marketing',
            },
            {
                title: 'footer.operations.title',
                defaultTitle: 'For operations',
            },
            {
                title: 'footer.personal.title',
                defaultTitle: 'For you and your family',
            },
        ],
        topNavigations: {
            forMarketing: {
                path: 'https://www.trades.org/trade-pro/marketing-services',
                links: [
                    {
                        title: 'footer.marketing.links.1',
                        defaultTitle: 'Website optimized to produce leads',
                    },
                    {
                        title: 'footer.marketing.links.2',
                        defaultTitle: 'Social profiles, set up and managed',
                    },
                    {
                        title: 'footer.marketing.links.3',
                        defaultTitle: 'Phone, chat, and email answering',
                    },
                    {
                        title: 'footer.marketing.links.4',
                        defaultTitle: 'Job review and reputation management',
                    },
                    {
                        title: 'footer.marketing.links.5',
                        defaultTitle: 'Logo design, business cards, and more',
                    },
                    {
                        title: 'footer.marketing.links.6',
                        defaultTitle: "'Only pay when you close' leads",
                    },
                ],
            },
            forOperations: {
                path: 'https://www.trades.org/trade-pro/operations',
                links: [
                    {
                        title: 'footer.operations.links.1',
                        defaultTitle: 'Project financing for your customers',
                    },
                    {
                        title: 'footer.operations.links.2',
                        defaultTitle: 'Business insurance by period or project',
                    },
                    {
                        title: 'footer.operations.links.3',
                        defaultTitle: 'Invoicing, billing, collections, and liens',
                    },
                    {
                        title: 'footer.operations.links.4',
                        defaultTitle: 'Standard contracts for projects and subs',
                    },
                    {
                        title: 'footer.operations.links.5',
                        defaultTitle: 'Access to network of qualified subs',
                    },
                    {
                        title: 'footer.operations.links.6',
                        defaultTitle: 'Discounted materials pricing',
                    },
                ],
            },
            forYouandFamily: {
                path: 'https://www.trades.org/trade-pro/personal',
                links: [
                    {
                        title: 'footer.personal.links.1',
                        defaultTitle: 'Personal health, dental, and vision',
                    },
                    {
                        title: 'footer.personal.links.2',
                        defaultTitle: 'Tax-advantaged retirement programs',
                    },
                    {
                        title: 'footer.personal.links.3',
                        defaultTitle: 'Personal and equipment financing',
                    },
                    {
                        title: 'footer.personal.links.4',
                        defaultTitle: 'Credit building and financial support',
                    },
                    {
                        title: 'footer.personal.links.5',
                        defaultTitle: 'Educational concierge and resources',
                    },
                    {
                        title: 'footer.personal.links.6',
                        defaultTitle: 'Free and discounted partner perks',
                    },
                ],
            },
        },
        socialLinks: [
            {
                href: 'https://www.facebook.com/trades.org',
                target: '_blank',
                ariaLabel: 'Facebook',
                icon: <FiFacebook size={24} stroke="#618faf" />,
            },
            {
                icon: <FiInstagram size={24} stroke="#618faf" />,
                href: 'https://www.instagram.com/trades_org',
                target: '_blank',
                ariaLabel: 'Instagram',
            },
        ],
        footerNavigations: [
            {
                key: 'footer.titles.privacy',
                options: 'Privacy',
                path: 'https://www.trades.org/trade-pro/privacy',
            },
            {
                key: 'footer.titles.terms',
                options: 'Terms',
                path: 'https://www.trades.org/trade-pro/terms',
            },
            {
                key: 'footer.titles.contact',
                options: 'Contact',
                path: 'https://www.trades.org/trade-pro/contact',
            },
        ],
    },
};

export default navigationData;
